import { type FC } from 'react'

import IconCaretDown from './IconCaretDown'
import IconCaretLeft from './IconCaretLeft'
import IconCaretRight from './IconCaretRight'
import IconCaretUp from './IconCaretUp'
import { type IconProps } from './SvgIcon'

type Props = IconProps & {
  direction: 'up' | 'right' | 'down' | 'left'
}

const DIRECTION_TO_COMPONENT_MAP = {
  up: IconCaretUp,
  right: IconCaretRight,
  down: IconCaretDown,
  left: IconCaretLeft,
}

const Icon: FC<Props> = ({ direction, ...props }) => {
  const IconCaret: FC<IconProps> = DIRECTION_TO_COMPONENT_MAP[direction]
  return <IconCaret {...props} />
}

export default Icon
